/* eslint-disable no-param-reassign,no-unused-vars */
/* global G */
import { curry, setKey } from 'lib/util'
import validate from 'lib/sequence/model/validate'
import asObject from 'lib/sequence/component/children/asObject'
import { checked } from 'lib/sequence/component/state/checked'
import refresh from 'lib/sequence/model/api/refresh'
import { v4 as uuidV4 } from 'uuid'
import find from 'lib/sequence/component/children/find'

/**
 * Event Handler Child Add.
 *
 * Validates the current form and uses its data to add or modify a new or existing sub-model to the
 * base model.
 *
 * @param {string} name                   the name of the child model
 * @param {Gaia.AppModule.Spec} module    the current module composition object
 * @param {Gaia.Component.Spec} component the current action's main component
 * @param {Event} event                   information about the event that triggered this handler
 * @returns {Promise<void>}
 */
export default curry(async (name, module, component, event) => {
  const model = module[G.MODEL]
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
  const child = model[G.CHILDREN][name]
  const { store } = find(actionComponent[G.ACTIONS][0])
  const childExists = !!child[G.CACHE]?._rev
  const storeChecked = checked(store)
  // obtaining child's current ref (if any)
  const ref = child[G.STATE][G.REF]
  // validating current form component against child
  await validate(child)(actionComponent)
  // setting module error from model
  module[G.STATE][G.ERROR] = child[G.STATE][G.ERROR]
  // checking validation error
  if (!child[G.STATE][G.ERROR]) {
    // If the child model doesn't exist, we toggle both the creation of its id and whether we are
    // adding the record with the bulk flag. Otherwise, if the child model exists, we always keep
    // its ID, the only difference is whether we are updating the original record or not
    if (!childExists) {
      storeChecked
        ? setKey(ref || uuidV4(), G.REF, child[G.STATE])
          && (child[G.DATA].key = child[G.STATE][G.REF])
        : setKey(null, G.REF, child[G.STATE])
          && delete child[G.DATA].key
          && delete child[G.STATE]?.[G.DATA]?.key
    }

    await refresh(child)
    child[G.DATA].status = 50
    child[G.STATE][G.BULK] = storeChecked
    // setting action's dirty flag
    setKey(false, G.UNDO, module[G.STATE][G.ACTION][G.STATE])
  } else {
    module[G.ADAPTER][G.UI].update(module)
  }
})
